import React, { useState, useEffect } from "react";

const Base64ToPDFViewer = ({ base64String }) => {
  const [pdfData, setPdfData] = useState(null);

  const base64ToUint8Array = (base64) => {
    const binaryString = window.atob(base64);
    const uint8Array = new Uint8Array(binaryString.length);

    for (let i = 0; i < binaryString.length; i++) {
      uint8Array[i] = binaryString.charCodeAt(i);
    }

    return uint8Array;
  };

  useEffect(() => {
    let pdfUrl;

    if (base64String) {
      const loadPDF = () => {
        const base64EncodedData = base64String?.split(',')[1] || base64String;

        try {
          const uint8Array = base64ToUint8Array(base64EncodedData);
          const pdfBlob = new Blob([uint8Array], { type: "application/pdf" });
          pdfUrl = URL.createObjectURL(pdfBlob);
          setPdfData(pdfUrl);
        } catch (error) {
          console.error("Error decoding Base64 string: ", error);
        }
      };

      loadPDF();

      return () => {
        if (pdfUrl) URL.revokeObjectURL(pdfUrl);
      };
    }
  }, [base64String]);

  return (
    <div className="flex border-2 w-full h-full">
      {pdfData && (
        <iframe src={pdfData} type="application/pdf" className="w-full h-full" title="pdf view" />
      )}
    </div>
  );
};

export default Base64ToPDFViewer;